import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const COLOR_SCHEMES = ['auto', 'light', 'dark'];

const prefersDarkQuery = () =>
  window.matchMedia('(prefers-color-scheme: dark)');

export const getColorScheme = () => {
  const scheme = LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME);
  return COLOR_SCHEMES.includes(scheme) ? scheme : 'auto';
};

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme = getColorScheme();
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};

export const saveColorScheme = scheme => {
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, scheme);
  setColorTheme(prefersDarkQuery().matches);
};

// Applies the saved scheme and keeps "auto" in sync with the OS setting.
export const followColorScheme = () => {
  const query = prefersDarkQuery();
  setColorTheme(query.matches);
  query.addEventListener('change', event => setColorTheme(event.matches));
};
